export const DEFAULT_EPERPUS_BUCKET = 'jsit';
export const NAIKA_EPERPUS_BUCKET = 'school';

export const DEFAULT_EPERPUS_NAME = 'Perpustakaan Digital';
export const NAIKA_EPERPUS_NAME = 'Repositori Materi';

export const isNaikaEperpus = (featureConfig) => featureConfig?.naika === true;

export const getEperpusBucket = (featureConfig) =>
  (isNaikaEperpus(featureConfig) && NAIKA_EPERPUS_BUCKET) || DEFAULT_EPERPUS_BUCKET;

export const getEperpusDisplayName = (featureConfig) =>
  (isNaikaEperpus(featureConfig) && NAIKA_EPERPUS_NAME) || DEFAULT_EPERPUS_NAME;

export const getEperpusBucketFromSchool = (school, schoolId) => {
  const activeSchoolId = school?.id ?? school?.school_id;

  if (String(activeSchoolId) !== String(schoolId)) {
    return DEFAULT_EPERPUS_BUCKET;
  }

  return getEperpusBucket(school?.feature_config ?? school?.feature_configs);
};

export const getEperpusDisplayNameFromSchool = (school, schoolId) => {
  const activeSchoolId = school?.id ?? school?.school_id;

  if (String(activeSchoolId) !== String(schoolId)) {
    return DEFAULT_EPERPUS_NAME;
  }

  return getEperpusDisplayName(school?.feature_config ?? school?.feature_configs);
};
